import { Injectable } from '@angular/core'
import { Bandeira } from '../../pkw-data/collect/bandeira.model'
import { Agente } from '../../pkw-data/collect/estabelecimento/agente.model'
import { OperadoraDeMaquina } from '../../pkw-data/collect/operadora-de-maquina.model'
import { PkwDatastore } from '../../pkw-data/pkw-datastore'
import { Comparator } from '../util/comparator'
import { novoStatus } from '../../extratos/exportacao-movimento/novoStatus';

@Injectable()
export class OperadoraDeMaquinaService {

  novoStatus: novoStatus
  operadoraDeMaquina: OperadoraDeMaquina

  constructor(private pkwDatastore: PkwDatastore) {
    }

  obterTodas() {
    return this.pkwDatastore
      .findAll(OperadoraDeMaquina, {
        page: { limit: 1000 },
        sort: 'nome'
      }).map(response =>
        response.getModels()
        .sort((operadoraA, operadoraB) =>
          Comparator.string(operadoraA.nome, operadoraB.nome)
        )
      )
  }

  obterInativas() {
    return this.pkwDatastore
      .findAll(OperadoraDeMaquina, {
        page: { limit: 1000 },
        sort: 'nome',
        filter: { ativo: false }
      })
    .map(response => response.getModels())
  }

  obterIndisponiveis() {
    return this.pkwDatastore
      .findAll(OperadoraDeMaquina, {
        page: { limit: 1000 },
        sort: 'nome',
        filter: { disponivel: false }
      })
    .map(response => response.getModels())
  }

  obterPossuemEstabelecimentos() {
    return this.pkwDatastore
      .findAll(Agente, {
        page: { limit: 1000 },
        sort: 'operadoraDeMaquina.nome',
        include: 'operadoraDeMaquina'
      })
      .map(response => response.getModels()
      .map(agente => agente.operadoraDeMaquina)
      .filter((operadora, i, array) => array.indexOf(operadora) === i)
      .sort((operadoraA, operadoraB) =>
          Comparator.string(operadoraA.nome, operadoraB.nome)
        )
      )
  }

  obterTodasBandeiras() {
    return this.pkwDatastore
      .findAll(Bandeira, { page: { limit: 1000 } })
      .map(response => response.getModels()
        .sort((bandeiraA, bandeiraB) =>
          Comparator.string(bandeiraA.descricao, bandeiraB.descricao)
        )
      )
  }

  obterPorCodename(codename: string) {
    return this.pkwDatastore
      .findAll(OperadoraDeMaquina, {
        filter: { codename }
      }).map(response => response.getModels()[0])
  }

  obterOperadoras() {
    return this.pkwDatastore
    .findAll(OperadoraDeMaquina, {
      page: { limit: 1000 },
      sort: 'nome'
    }).map(response =>
      response.getModels()
      .sort((operadoraA, operadoraB) =>
        Comparator.string(operadoraA.nome, operadoraB.nome)
      )
    )
  }

atualizarNovaOperadora(id: string) {
    return this.pkwDatastore
    .findRecord(OperadoraDeMaquina, id).subscribe(
    (post: OperadoraDeMaquina) => {
    post.novaOperadora = false;
    post.save().subscribe();
    }
    );
    }


}



// WEBPACK FOOTER //
// ./src/app/core/services/operadora-de-maquina.service.ts